module.exports = __webpack_public_path__ + "img/6手机.abb37aef.png";